import { ref } from "../../../types/_types";

import { Imprint } from "./Imprint";

export const ImprintRef = ref(Imprint, {
	name: true,
});
